import type { MessengerFacebookViewSettings } from '@widgets/messenger/types'
import { useWidgetChannels } from '@widgets/messenger/compositions/useWidgetChannels'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const useWidgetFacebookViewSettings = () => {
  const { widgetSettings } = useWidgetStore()
  const { channelMap } = useWidgetChannels()

  return computed<MessengerFacebookViewSettings>(() => {
    const { facebookChatUrl, uiSettings } = widgetSettings.value.channels[WebWidgetChannelType.FACEBOOK]
    const { title, description, buttonText } = uiSettings.mainScreen

    return {
      channel: channelMap.value[WebWidgetChannelType.FACEBOOK],
      facebookChatUrl,
      title,
      description,
      buttonText,
      showQrCode: uiSettings.showQrCode,
    } satisfies MessengerFacebookViewSettings
  })
}
